<template>
  <img
    class="object-contain w-full"
    alt="Symbol logo"
    src="@/assets/image/logo-symbol.svg"
  />
</template>